import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { appendModel } from '../../../../features/site/siteSlice'
import { oauthConsts, OVERRIDE_ID_BING } from '../../../utils/common'

const INITIAL_STATE = {
    customer: {},
    account: {}
}

function MicrosoftAds(props){
    const oauthConst = oauthConsts()

    const dispatch = useDispatch()
    const [state, setState] = useState(INITIAL_STATE)

    const isAdmin = useSelector(state => state.session.isAdmin)
    const model = useSelector(state => state.site.model)
    const oauthTokens = useSelector(state => state.session.oauthTokens)
    
    const AddAccParent = (p) => props.design === "onboarding" ? <div className="text-center">
        {p.children}
    </div> : <>{p.children}</>
    
    useEffect(() => {
        if(state.account !== INITIAL_STATE.account){

            let { account, customer } = state 
            const map = {
                tokenId: oauthTokens.bing?.id,
                customerId: customer.id,
                accountName: account.name,
                customerName: customer.name,
                accountId: account.id
            }
            
            let sForm = {
                ...model.siteForm,
                attr: {
                    ...model.siteForm.attr,
                    accounts: {
                        ...(model.siteForm.attr.accounts ? model.siteForm.attr.accounts : []),
                        bing: map
                    }
                }
            }

            localStorage.setItem("bingSelection", JSON.stringify({
                account: account.id,
                accountKey: account.key,
                customer: customer.id,
                customerKey: customer.key,
                map: JSON.stringify({...map})
            }))

            dispatch(appendModel({siteForm: sForm}))
            props.onSelectionUpdated("bing")
        }
    }, [state.account])
    
    const { siteForm, sites, siteActiveIdx } = model
    const { account, customer } = state

    const hrefOauth = `${oauthConst.bingAdsAuthURL}&state=${props.design === "onboarding" ? "/onboarding/" : "/admin/"}${siteForm.siteId}/bing`
    const site = sites[siteActiveIdx]

    return <>
        {(!model.reseller || (model.reseller && !model.isAffiliate)) && (!siteForm?.attr?.accounts?.bing && oauthTokens?.bing) && <>
            <div className="d-flex justify-content-end mb-3">
                <div className="btn-group">
                    <a href={hrefOauth} className="btn btn-lg btn-info">
                        <i class="fas fa-sync-alt"></i> Refresh
                    </a>
                </div>
            </div>
            <form>
                <div class="form-group">
                    <label for="acct">Customer</label>
                    <select className="form-control" onChange={(e) => setState(prev => ({...prev, account: INITIAL_STATE.account, customer: {...oauthTokens?.bing?.accounts[e.target.value], key: e.target.value}}))} value={customer?.key}>
                        <option></option>
                        {oauthTokens?.bing?.accounts?.map((item, key) => <option key={key} value={key}>{item.name}</option>)}
                    </select>
                </div>
                <div class="form-group">
                    <label for="acct">Account</label>
                    <select className="form-control" onChange={(e) => setState(prev => ({...prev, account: {...customer?.accounts[e.target.value], key: e.target.value}}))} value={account?.key}>
                        <option></option>
                        {customer?.accounts?.map((acct, key) => <option key={key} value={key}>{acct.name}</option>)}
                    </select>
                </div>
            </form>
        </>}
        {siteForm?.attr?.accounts?.bing && <div>
            {(!model.reseller || (model.reseller && !model.isAffiliate)) && sessionStorage.getItem(OVERRIDE_ID_BING) && <h5 className="alert alert-info">
                Click the Save button to complete the reset token process
            </h5>}
            {(!model.reseller || (model.reseller && !model.isAffiliate)) && <div className={`d-flex justify-content-${isAdmin && siteForm?.attr?.accounts?.bing.refreshRequired ? 'between' : 'end'} mb-3`}>
                {isAdmin && siteForm?.attr?.accounts?.bing.refreshRequired && <div class="alert alert-danger mb-0" role="alert">
                    <strong>Next Alert Date:</strong> {siteForm?.attr?.accounts?.bing.refreshAlertDate}
                </div>}
                <div className="btn-group">
                    {!sessionStorage.getItem(OVERRIDE_ID_BING) && siteForm?.attr?.accounts?.bing?.refreshRequired && <button className="btn btn-lg btn-danger" onClick={() => props.onResetToken("bing", hrefOauth)}>
                        <i class="fas fa-trash-alt"></i> Reset Token
                    </button>}
                    {isAdmin && <button className="btn btn-lg btn-outline-danger" onClick={() => props.onDeleteService("bing")}>
                        <i class="fas fa-trash-alt"></i> Delete
                    </button>}
                </div>
            </div>}
            {isAdmin && <div className="d-flex justify-content-start">
                <i className="fas fa-id-badge mr-1 fa-1-5"></i>
                <strong className="mr-1">Token ID: </strong>
                <h5>{siteForm?.attr?.accounts?.bing?.tokenId}</h5>
            </div>}
            <h3>
                <small className="text-muted">Customer:</small> {siteForm.attr?.accounts.bing.customerName}
            </h3>
            <h3>
                <small class="text-muted">Account:</small> {siteForm.attr?.accounts.bing.accountName}
            </h3>          
        </div>}
        {(!model.reseller || (model.reseller && !model.isAffiliate)) && (!siteForm?.attr?.accounts?.bing && !oauthTokens?.bing) && <AddAccParent>
            <a class="btn btn-success btn-lg" href={hrefOauth}>Add Account</a>
        </AddAccParent>}
    </>
}

MicrosoftAds.defaultProps = {
    design: "admin",
    onSelectionUpdated: () => null
}

export default MicrosoftAds